import { atom } from 'recoil';

interface IPixData {
  digitableLine: string;
  expiry: string;
}

export const pixData = atom<IPixData | null>({
  key: 'pixData',
  default: null,
});
